// extracted by mini-css-extract-plugin
module.exports = {"simple-switch":"styles_simple-switch__BxRX-","grey":"styles_grey__gJ2fQ","blue":"styles_blue__1LwHB"};